module.exports = __webpack_public_path__ + "img/KZ.d013049a.png";